import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "io-mfe-ig-footer-auto-save" }
const _hoisted_3 = { class: "io-mfe-ig-footer-types-holder" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Reset", -1)
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row q-gutter-sm" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "submit-error-dialog-card-title" }, "We were unable to submit your DRG at this time", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "Please contact support with error \"unable to submit DRG\", URL of your case, date and time the issue occurred.", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"20px"} }, "Please note that other users are unable to see your codes until the DRG has been submitted.", -1)

import { computed, ref, VNodeRef} from 'vue';
import _ from 'lodash';
import DropDown from 'components/global-common/DropDown.vue';
import { useGrouperStore } from 'stores/grouper-store';
import { SUBMIT_OPTIONS } from 'components/grouper-common/common-constants';
import CalculateAprBanner from 'components/grouper-common/CalculateAprBanner.vue';
import { storeToRefs } from 'pinia';
import {showSuccessSnackBar} from 'src/services/snackbarService';
import { discardDraft as discardDrafApi } from 'src/services/GrouperService';
import {GrouperLayoutMode} from 'src/services/IodineGrouperService';
import {useLayoutStore} from 'stores/layout-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperFooter',
  setup(__props) {

const grouperStore = useGrouperStore();
const { submitDrgTypes, isPrimaryDrgMs, queueEmpty, oldPrimaryDrg, secondaryDRG, readOnly } = storeToRefs(grouperStore);
const banner = ref<VNodeRef|null>(null);
const submitErrorShow = ref(false);
const canSubmit = computed(() => !_.isEmpty(submitDrgTypes.value) && grouperStore.canSubmitDrg);
const { layoutMode } = storeToRefs(useLayoutStore());

function saveDrg() {
    grouperStore.saveDrg().catch(function () {
      submitErrorShow.value = true;
    });
}

function checkForBanner() {
  if (canSubmit.value) {
    banner.value?.toggle(false);
    return;
  }

  banner.value?.toggle(!!grouperStore.aprCalcNeededForSubmit);
}

// TODO why are these undefined return values
function getSaveOrDraftMessage(): string | undefined {
  if (grouperStore.isDirty) {
    return ': Draft';
  } else if(!_.isEmpty(grouperStore.getLastSubmittedTypes)) {
    return ' Saved: ';
  }
}

function getSavedTypesDisplay(): string | undefined {
  if (grouperStore.isDirty) {
    return '';
  } else if(!_.isEmpty(grouperStore.getLastSubmittedTypes)) {
    return grouperStore.getLastSubmittedTypes.join(', ');
  }
}

function resetDraft() {
  if (!grouperStore.isDirty || readOnly.value) {
    return;
  }
  
  // Capture current state before reset for undo functionality
  const preResetState = grouperStore.getDraftState();
  
  let shouldDiscardDraft = true;
  
  grouperStore.reloadVisit(true); // Always ignore draft on reset

  let message;
  if (oldPrimaryDrg.value.drg || secondaryDRG.value.drg) {
    message = 'Draft has been reset and returned to previous working code saved.'
  } else {
    message = 'Draft has been reset and returned to default view.';
  }

  showSuccessSnackBar(message, [{
    label: 'Undo',
    handler: () => {
      shouldDiscardDraft = false;
      
      // Restore from captured state, not from server draft
      grouperStore.setDraftState(preResetState);
      
      // Save the restored state as draft immediately
      grouperStore.saveDraftImmediately().catch((error) => {
        console.error('Failed to save restored draft:', error);
      });
    }
  }], 10000, true, () => {
    if (shouldDiscardDraft) {
      discardDrafApi();
    }
  });
}


return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_card, {
      class: _normalizeClass(["iodine-footer", {'embedded-footer': _unref(layoutMode) == _unref(GrouperLayoutMode).consolidated}])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_q_space),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_q_icon, {
                class: _normalizeClass(["io-mfe-ig-icon-small", {'io-mfe-ig-icon-success': !_unref(grouperStore).isDirty && !_unref(_).isEmpty(_unref(grouperStore).getLastSubmittedTypes)}]),
                name: "fa-light fa-file-pen"
              }, null, 8, ["class"]),
              _createElementVNode("span", null, _toDisplayString(_unref(isPrimaryDrgMs) ? 'MS' : 'APR') + " DRG" + _toDisplayString(getSaveOrDraftMessage()), 1),
              _createElementVNode("span", {
                class: _normalizeClass({'io-mfe-ig-footer-auto-save-types': getSavedTypesDisplay()})
              }, [
                _createTextVNode(_toDisplayString(getSavedTypesDisplay()) + " ", 1),
                (getSavedTypesDisplay())
                  ? (_openBlock(), _createBlock(_component_q_tooltip, {
                      key: 0,
                      offset: [0, 3]
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getSavedTypesDisplay()), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _createElementVNode("div", {
              onClick: resetDraft,
              class: _normalizeClass(["io-mfe-ig-footer-reset", {'io-mfe-ig-footer-reset-disabled': !_unref(grouperStore).isDirty || _unref(readOnly)}])
            }, [
              (_unref(grouperStore).isDirty && !_unref(readOnly))
                ? (_openBlock(), _createBlock(_component_q_tooltip, {
                    key: 0,
                    offset: [0, 3]
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Reset Draft ")
                    ]),
                    _: 1
                  }))
                : (!_unref(readOnly))
                  ? (_openBlock(), _createBlock(_component_q_tooltip, {
                      key: 1,
                      offset: [0, 3]
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Draft Reset Unavailable. The draft cannot be reset since no changes have been made. ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
              _createVNode(_component_q_icon, {
                class: _normalizeClass(["io-mfe-ig-icon-small", {'io-mfe-ig-icon-success': !_unref(grouperStore).isDirty && !_unref(_).isEmpty(_unref(grouperStore).getLastSubmittedTypes)}]),
                name: "fa-light fa-arrow-rotate-left"
              }, null, 8, ["class"]),
              _hoisted_4
            ], 2)
          ]),
          _createVNode(_component_q_form, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createVNode(DropDown, {
                      modelValue: _unref(submitDrgTypes),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(submitDrgTypes) ? (submitDrgTypes).value = $event : null)),
                      options: _unref(SUBMIT_OPTIONS),
                      "option-label": "label",
                      "option-value": "value",
                      label: "Save As",
                      "iodine-class-name": "drg-save-as",
                      multiple: "",
                      "check-boxes": "",
                      "disabled-option-tooltip": "Please calculate a DRG first",
                      disable: !_unref(grouperStore).canSubmitDrg || !_unref(queueEmpty) || _unref(readOnly),
                      "popup-content-class": "io-mfe-ig-submit-dropdown"
                    }, null, 8, ["modelValue", "options", "disable"]),
                    (!_unref(readOnly) && (!_unref(grouperStore).canSubmitDrg || !_unref(queueEmpty)))
                      ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Please calculate a DRG first ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_btn, {
                      onClick: saveDrg,
                      onMouseover: checkForBanner,
                      unelevated: "",
                      class: _normalizeClass(["iodine-submit-button", { 'io-mfe-ig-submit-disabled': !canSubmit.value || !_unref(queueEmpty) }]),
                      disable: !canSubmit.value || !_unref(queueEmpty)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Submit ")
                      ]),
                      _: 1
                    }, 8, ["class", "disable"])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(CalculateAprBanner, {
      ref_key: "banner",
      ref: banner
    }, null, 512),
    _createVNode(_component_q_dialog, {
      modelValue: submitErrorShow.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((submitErrorShow).value = $event)),
      class: "submit-error-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "submit-error-dialog-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { style: {"padding":"21px 24px 16px 24px"} }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "submit-error-dialog-card-body" }, {
              default: _withCtx(() => [
                _hoisted_8,
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, {
              align: "right",
              style: {"margin":"0 20px 0 0"}
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  unelevated: "",
                  label: "Dismiss",
                  class: "submit-error-dialog-card-action"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})